import type { CommentsApiClient } from "./comments-api-client";
import type { CommentsUploadClient } from "./comments-upload-client";
import type { CommentDto, CommentSubjectRef } from "./types";

export interface CommentDraft {
	content: string;
	file?: File | null;
}

export class CommentsComposerController {
	constructor(
		private readonly apiClient: Pick<CommentsApiClient, "create">,
		private readonly uploadClient: Pick<CommentsUploadClient, "upload">,
	) {}

	async submit(
		ref: CommentSubjectRef,
		draft: CommentDraft,
	): Promise<{ success: boolean; comment?: CommentDto; error?: string }> {
		const trimmedContent = draft.content.trim();
		if (!trimmedContent && !draft.file) {
			return {
				success: false,
				error: "Comment content or attachment is required",
			};
		}

		let attachment: {
			url: string;
			filename: string;
			mimeType: string;
			size: number;
		} | null = null;

		if (draft.file) {
			// Upload stays decoupled from comment creation so the same pipeline can be reused by other subjects.
			const uploadResult = await this.uploadClient.upload(draft.file);
			if (!uploadResult.success || !uploadResult.attachment) {
				return {
					success: false,
					error: uploadResult.error || "Failed to upload file",
				};
			}
			attachment = uploadResult.attachment;
		}

		return this.apiClient.create(ref, {
			content: trimmedContent,
			attachment,
		});
	}
}
